const collectionsPage = {
  key: 'collectionsPage',
  name: 'Collections',
  seoDescriptionLabel: `Shop our selection of {collectionTitle} in the official PetSafe® store for your pet.`,
  defaultCollectionTitleLabel: 'PetSafe Products',
  allProductsCollectionTitleLabel: 'All Products',
};

exports.collectionsPage = collectionsPage;
